export class SigncoError {
    constructor(public error: string) {

    }
}